import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g stroke={color} strokeWidth={2}>
      <path clipRule="evenodd" d="m4 17 7-12h2l7 12-1 2H5z" />
      <path d="M12 9v4m0 2v2" />
    </g>
  </svg>
);
